module.exports = __webpack_public_path__ + "img/wf-pdf.26c4f0e2.svg";